import { axios } from 'lib/axios';

export const loginWithGoogleAuthenticator = async (data) => {
  return await axios.post('/user/authenticator/login', data);
};
